import { FacebookPlatform } from '@app/modules/social-export/domain/platforms';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { DefaultPlatformConnect } from '../../../screens/manage/DefaultPlatformConnect';
type Props = {
  stationId: string;
};

export function FacebookConnect({ stationId }: Props) {
  const { $t } = useIntl();

  return (
    <div>
      <Alert icon={<InfoOutlinedIcon />} severity="warning" sx={{ mb: 2 }}>
        <FormattedMessage
          id="socialExport.facebook.permissionsNote"
          defaultMessage="IMPORTANTE: al momento de dar permisos a la aplicación, se debe dar acceso solamente a la página en la cual se desea publicar."
        />
      </Alert>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <DefaultPlatformConnect platform={FacebookPlatform} stationId={stationId}>
          {$t({
            id: 'socialExport.connect',
            defaultMessage: 'Conectar',
          })}
        </DefaultPlatformConnect>
        <DefaultPlatformConnect
          platform={FacebookPlatform}
          stationId={stationId}
          loginSuffix="business"
        >
          {$t({
            id: 'socialExport.facebook.connectBusiness',
            defaultMessage: 'Conectar (Facebook Business)',
          })}
        </DefaultPlatformConnect>
      </Box>
    </div>
  );
}
